import React from 'react';
// import HomePage from '../pages/HomePage';
import BankPage from '../pages/BankPage';
import PaymentDepositPage from '../pages/PaymentDepositPage';
import AppGuidePage from '../pages/AppGuidePage';
import XsmbPage from '../pages/XsmbPage';
// import BankDownloadPage from '../pages/BankDownloadPage';
// import PaymentEarnMoneyPage from '../pages/PaymentEarnMoneyPage';
// import UserProfilePage from '../pages/UserProfilePage';
import TransactionHistoryPage from '../pages/TransactionHistoryPage';
// import UserChangePasswordPage from '../pages/UserChangePasswordPage';
import AppCookie from '../helpers/AppCookie';
import { Navigate, useNavigate } from 'react-router-dom';
import AuthMoldel from "../models/AuthMoldel";

const LogOut = () => {
	let navigate = useNavigate();
	// lấy thông tin máy và trình duyệt
	const browserInfo = navigator.userAgent;
	AuthMoldel.logout({
		browserInfo:browserInfo
	}).then((res) => {
		AppCookie.deleteCookie('token');
		AppCookie.deleteCookie('user');
		navigate('/login');
	}).catch((err) => {
		console.log(err);
	});
}

const HomePage = () => {
	return <Navigate to="/bank" replace />;
}

const users = [
	{ path: '/', element: <HomePage /> },
	{ path: '/logout', element: <LogOut /> },
	{ path: '/bank', element: <BankPage /> },
	{ path: '/payment/deposit', element: <PaymentDepositPage /> },
	{ path: '/transaction/history', element: <TransactionHistoryPage /> },
	{ path: '/app-guide', element: <AppGuidePage /> },
	{ path: '/xsmb', element: <XsmbPage /> },
];

export default users;
